<template>
  <v-dialog persistent v-model="dialog" width="700">
    <template>
      <v-card>
        <v-toolbar dark color="primary"> Informações </v-toolbar>
        <v-card-text class="mt-5 p-0">
          <div class="text flex-column justify-center mt-3">
            <p class="text-center">
              <v-icon x-large color="green darken-2 " aria-hidden="true"
                >fa fa-check-square fa-4x</v-icon
              >
            </p>
            <p class="text-justify mb-0">
              Carteira retirada por
              <strong>{{ dataAluno.nome_pessoa }}</strong> no endereço
              <strong>{{ dataAluno.endereco }}</strong> .
            </p>
            <p v-if="isAluno">
              A entrega foi realizada por
              <strong>{{ dataAluno.usulog }}</strong> no dia
              <strong>{{ formatDate(dataAluno.dtSolicitacao) }}</strong>.
            </p>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn @click="closeDialog">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import * as _ from "lodash";
import moment from "moment";
import dayjs from "dayjs";

export default {
  name: "AtendimentoVaiVem",
  props: {
    dataAluno: Object,
    dialog: Boolean,
    closeDialog: Function,
    isAluno: Boolean
  },
  data() {
    return {
      aluno: [],
      openDialog: false,
    };
  },
  methods: {
    formatDate(date) {
      const formatDate = dayjs(date).format("DD/MM/YYYY");
      return formatDate;
    },
  },
};
</script>
